<div role="navigation">
    <router-outlet />
</div>
